import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-trader-gray dark:rounded flex flex-col overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "font-bold flex-shrink-0 bg-trader-darkest-gray p-2 text-white border-b-2 border-trader-dark-gray"
}



// Define props

export default /*@__PURE__*/_defineComponent({
  __name: 'TRContainer',
  props: {
    title: {},
    scrollable: { type: Boolean },
    direction: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-grow gap-2 p-2", [_ctx.scrollable ? 'overflow-auto' : 'flex overflow-hidden', _ctx.direction === 'row' ? 'flex-row' : 'flex-col']])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})